module.exports = __webpack_public_path__ + "static/media/3.1a64359e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/3.jpg
// module id = 194
// module chunks = 0